module.exports = __webpack_public_path__ + "img/middle-btn.0d27b893.png";